import { queryOptions } from '@tanstack/react-query';
import { service } from '@maia/insurance';

export function getInsuranceDocuments(
  params: Parameters<typeof service.getInsuranceDocuments>[0],
) {
  return queryOptions({
    queryKey: ['insurance', 'documents', params.insuranceGuid],
    queryFn: () => service.getInsuranceDocuments(params),
  });
}
